import styled from 'styled-components';
import { Typ35 } from 'dc/Typ';
import EmojiComponent from 'dc/Emoji';

type WrapperProps = {
  isSmall?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: ${props => (props.isSmall ? '0 16px' : '0 40px;')};
`;

export const Text = styled(Typ35)`
  font-family: Hind, sans-serif;
`;

type ButtonProps = {
  color: string;
  hoverColor: string;
};

export const Button = styled.button<ButtonProps>`
  height: 48px;
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: none;
  background: ${props => props.color};
  margin-left: 16px;
  cursor: pointer;
  &&:hover {
    background: ${props => props.hoverColor};
  }
`;

export const Emoji = styled(EmojiComponent)``;
